async function postJson(url, payload = {}) {
  const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "X-CSRF-Token": csrfToken
    },
    body: JSON.stringify(payload)
  })

  const data = await response.json().catch(() => ({}))

  if (!response.ok) {
    throw new Error(data.error || "Request failed")
  }

  return data
}

function setMembershipStatus(message, isError = false) {
  const status = document.getElementById("paypal-membership-status")
  if (!status) return

  status.textContent = message
  status.classList.toggle("text-danger", isError)
  status.classList.toggle("text-muted", !isError)
}

async function setupMembershipCheckout() {
   let paymentCompleted = false
  const container = document.getElementById("paypal-membership-checkout")
  if (!container) return

  // Prevent duplicate setup when Turbo/DOMContentLoaded fire more than once
  if (container.dataset.initialized === "true") return
  container.dataset.initialized = "true"

  if (!window.paypal) {
    setMembershipStatus("PayPal checkout could not load.", true)
    return
  }

  const clientId = container.dataset.paypalClientId
  const createOrderUrl = container.dataset.createOrderUrl
  const captureOrderUrl = container.dataset.captureOrderUrl
  const cancelUrl = container.dataset.cancelUrl

  if (!clientId) {
    setMembershipStatus("PayPal client ID is missing.", true)
    return
  }

  try {
    const sdkInstance = await window.paypal.createInstance({
      clientId: clientId,
      components: ["paypal-payments"],
      pageType: "checkout"
    })

    const paymentMethods = await sdkInstance.findEligibleMethods({
      currencyCode: "USD"
    })

    if (!paymentMethods.isEligible("paypal")) {
      setMembershipStatus("PayPal checkout is not available for this transaction.", true)
      return
    }

   let paymentCompleted = false

const paypalSession = sdkInstance.createPayPalOneTimePaymentSession({
  onApprove: async (data) => {
    setMembershipStatus("Capturing payment…")

    const orderId = data.orderId || data.orderID || data.id

    if (!orderId) {
      console.error("PayPal approval data did not include an order ID:", data)
      setMembershipStatus("PayPal approved the payment, but no order ID was returned.", true)
      return
    }

    const result = await postJson(captureOrderUrl, {
      order_id: orderId
    })

    paymentCompleted = true

    if (result.redirectUrl) {
      window.location.href = result.redirectUrl
    } else {
      console.error("Capture response missing redirectUrl:", result)
      setMembershipStatus("Payment captured, but no success redirect was returned.", true)
    }
  },

  onCancel: () => {
    if (cancelUrl) {
      window.location.href = cancelUrl
    } else {
      setMembershipStatus("Checkout was cancelled.", true)
    }
  },

  onError: (error) => {
    console.error("PayPal checkout error:", error)

    if (paymentCompleted) {
      console.warn("Ignoring PayPal error because payment was already captured.")
      return
    }

    setMembershipStatus("PayPal checkout failed. Please try again.", true)
  }
})


    const paypalButton = container.querySelector("paypal-button")
    paypalButton.removeAttribute("hidden")

    paypalButton.addEventListener("click", async () => {
      try {
        const selectedMembershipType = document.querySelector("input[name='membership_type']:checked")?.value

        if (!selectedMembershipType) {
          setMembershipStatus("Please choose a membership type.", true)
          return
        }

        setMembershipStatus("Opening PayPal checkout…")

        await paypalSession.start(
          { presentationMode: "auto" },
          postJson(createOrderUrl, {
            membership_type: selectedMembershipType
          }).then((data) => ({
            orderId: data.orderId
          }))
        )
      } catch (error) {
        console.error("PayPal start error:", error)
        setMembershipStatus(error.message || "Could not start PayPal checkout.", true)
      }
    })

    setMembershipStatus("PayPal checkout is ready.")
  } catch (error) {
    console.error("PayPal setup error:", error)
    setMembershipStatus("PayPal checkout setup failed.", true)
  }
}

document.addEventListener("turbo:load", setupMembershipCheckout)

// document.addEventListener("DOMContentLoaded", setupMembershipCheckout)